import React from "react";
import { Table } from "react-bootstrap";
import { ActionMenu } from "../../Ads/ActionMenu/ActionMenu";
import { formatDate } from "../../../utils/formatUtils";
import type { CourseAssignment, CourseAssignmentStatus } from "../../../api/academyCourseAssignments/courseAssignmentsService";
import "../../../pages/Ads/Creatives/components/CreativeTable.css";

interface CourseAssignmentsTableProps {
  assignments: CourseAssignment[];
  onChangeStatus: (assignment: CourseAssignment, status: CourseAssignmentStatus) => void;
  onRequestRevoke: (assignment: CourseAssignment) => void;
}

const STATUS_CONFIG: Record<CourseAssignmentStatus, { className: string; label: string }> = {
  ASSIGNED: { className: "ads-tag--assigned", label: "Assigned" },
  REVOKED: { className: "ads-tag--revoked", label: "Revoked" },
};

const MANAGE_PERMS = [
  "academy_management.admin",
  "academy_management.enrollments.manage",
];

const CourseAssignmentsTable: React.FC<CourseAssignmentsTableProps> = ({
  assignments,
  onChangeStatus,
  onRequestRevoke,
}) => {
  return (
    <div className="ads-table-wrapper">
      <Table responsive className="ads-table">
        <thead>
          <tr>
            <th>Course</th>
            <th>Full Name</th>
            <th>Email</th>
            <th>Phone No</th>
            <th>Status</th>
            <th>Assigned At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {assignments.map((assignment) => {
            const statusCfg = STATUS_CONFIG[assignment.status] ?? STATUS_CONFIG.REVOKED;

            const actionItems = [];

            if (assignment.status === "ASSIGNED") {
              actionItems.push({
                key: "revoke",
                label: "Revoke",
                iconClassName: "ph-x-circle",
                anyOfPermissions: MANAGE_PERMS,
                hideWhenDisabled: true,
                isDanger: true,
                onSelect: () => onRequestRevoke(assignment),
              });
            } else {
              actionItems.push({
                key: "assign",
                label: "Assign",
                iconClassName: "ph-user-plus",
                anyOfPermissions: MANAGE_PERMS,
                hideWhenDisabled: true,
                onSelect: () => onChangeStatus(assignment, "ASSIGNED"),
              });
            }

            return (
              <tr key={assignment._id}>
                <td>{assignment.courseName}</td>
                <td>{assignment.fullName ?? "—"}</td>
                <td>{assignment.email ?? "—"}</td>
                <td>+{assignment.countryCode} {assignment.phoneNumber}</td>
                <td>
                  <span className={`ads-tag ${statusCfg.className}`}>
                    {statusCfg.label}
                  </span>
                </td>
                <td>{assignment.assignedAt ? formatDate(assignment.assignedAt) : "—"}</td>
                <td>
                  <ActionMenu
                    ariaLabel={`Actions for ${assignment.fullName ?? assignment.phoneNumber}`}
                    items={actionItems}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default CourseAssignmentsTable;
